module.exports = __webpack_public_path__ + "static/media/Y3.154169ff.mp3";